(()=>{
 const start=()=>{
  const root=document.querySelector('.mo-yellow-guide');if(!root)return;
  const slot=root.querySelector('[data-yellow-review-summary]');let ready=false;
  const sync=()=>{
   const widget=document.getElementById('judgeme_product_reviews');
   const badge=document.querySelector('.product__details .jdgm-prev-badge');
   const summary=widget?.querySelector('.jdgm-rev-widg__summary');
   if(!widget||(!summary&&!badge)||ready)return;
   const source=summary||badge;slot.replaceChildren(source.cloneNode(true));const score=widget.querySelector('[data-average-rating]')?.getAttribute('data-average-rating');if(score){const rating=document.createElement('strong');rating.className='mo-yellow-average';rating.textContent=score+' / 5';slot.prepend(rating);}
   const section=widget.closest('.shopify-section');if(section){section.classList.add('mo-yellow-reviews-collapsed');section.dataset.yellowReviewSection='true';}
   ready=true;
  };
  const observer=new MutationObserver(sync);observer.observe(document.body,{childList:true,subtree:true});sync();
  window.setTimeout(()=>observer.disconnect(),20000);
  const show=()=>{document.querySelector('[data-yellow-review-section]')?.classList.remove('mo-yellow-reviews-collapsed');};
  document.addEventListener('click',event=>{if(event.target.closest('[data-yellow-open-reviews],.product__details .jdgm-prev-badge'))show();});
 };if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();